import { CogIcon } from './CogIcon';

/**
 * author: Google
 * id E4A14909-3821-4DB1-A739-4DA464ABEEB7
 * name cog
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog.svg
 * tags
 * - Settings 
 */
export const SettingsIcon = CogIcon;
export default SettingsIcon